import { createSelector } from '@ngrx/store';
import { IEmployeeRiskProduct } from '../models/employee-risk-products.model';
import * as fromEmployeeMainReducer from '../employee-detail.reducer';
import * as fromEmployeeRiskProducts from '../reducers/employee-risk-products.reducer';

export const selectEmployeeRiskProductsState = createSelector(
  fromEmployeeMainReducer.getRootState,
  state => state[fromEmployeeRiskProducts.employeeRiskProductsFeatureKey]
);

export const selectEmployeeRiskProducts = createSelector(
  selectEmployeeRiskProductsState,
  state =>
    (state.response || []).reduce<IEmployeeRiskProduct[]>(
      (products, group) => products.concat(group.products || []),
      []
    )
);

export const selectEmployeeRiskProductGroups = createSelector(
  selectEmployeeRiskProductsState,
  fromEmployeeRiskProducts.getEmployeeRiskProductsResponse
);

export const selectEmployeeRiskProductsLoading = createSelector(
  selectEmployeeRiskProductsState,
  fromEmployeeRiskProducts.getEmployeeRiskProductsLoading
);

export const selectEmployeeRiskProductsUpdating = createSelector(
  selectEmployeeRiskProductsState,
  fromEmployeeRiskProducts.getEmployeeRiskProductsUpdating
);

export const selectEmployeeRiskProductsUpdatingGroup = createSelector(
  selectEmployeeRiskProductsState,
  fromEmployeeRiskProducts.getEmployeeRiskProductsUpdatingGroup
);

export const selectEmployeeRiskProductsDeleting = createSelector(
  selectEmployeeRiskProductsState,
  fromEmployeeRiskProducts.getEmployeeRiskProductsDeleting
);

export const selectEmployeeRiskProductsError = createSelector(
  selectEmployeeRiskProductsState,
  fromEmployeeRiskProducts.getEmployeeRiskProductsError
);

export const selectEmployeeRiskProductsUpdateError = createSelector(
  selectEmployeeRiskProductsState,
  fromEmployeeRiskProducts.getEmployeeRiskProductsUpdateError
);

export const selectEmployeeRiskProductsUpdateGroupError = createSelector(
  selectEmployeeRiskProductsState,
  fromEmployeeRiskProducts.getEmployeeRiskProductsUpdateGroupError
);

export const selectEmployeeRiskProductsDeleteError = createSelector(
  selectEmployeeRiskProductsState,
  fromEmployeeRiskProducts.getEmployeeRiskProductsDeleteError
);

export const selectRiskProductCalculationTypeOptions = createSelector(
  selectEmployeeRiskProductsState,
  fromEmployeeRiskProducts.getRiskProductCalculationTypeOptions
);

export const selectRiskProductDisplayTypeOptions = createSelector(
  selectEmployeeRiskProductsState,
  fromEmployeeRiskProducts.getRiskProductDisplayTypeOptions
);

export const selectRiskProductStaticDataError = createSelector(
  selectEmployeeRiskProductsState,
  fromEmployeeRiskProducts.getRiskProductStaticDataError
);

export const selectBusinessRiskGroupOptions = createSelector(
  selectEmployeeRiskProductsState,
  fromEmployeeRiskProducts.getBusinessRiskGroupOptions
);

export const selectBusinessRiskGroupOptionsLoading = createSelector(
  selectEmployeeRiskProductsState,
  fromEmployeeRiskProducts.getBusinessRiskGroupOptionsLoading
);

export const selectBusinessRiskGroupOptionsError = createSelector(
  selectEmployeeRiskProductsState,
  fromEmployeeRiskProducts.getBusinessRiskGroupOptionsError
);

export const selectStaticRiskProductOptions = createSelector(
  selectEmployeeRiskProductsState,
  fromEmployeeRiskProducts.getStaticRiskProductOptions
);

export const selectStaticRiskProductOptionsLoading = createSelector(
  selectEmployeeRiskProductsState,
  fromEmployeeRiskProducts.getStaticRiskProductOptionsLoading
);
